/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Foodstuff } from './Foodstuff';
import type { ImageMetadata } from './ImageMetadata';
import type { MealRatingStats } from './MealRatingStats';
import type { User } from './User';
export type Meal = {
    id?: string;
    userMealId?: string;
    author?: User;
    name?: string;
    recipeSteps?: Array<string>;
    mealtime?: string;
    foodstuffs?: Array<Foodstuff>;
    images?: Array<ImageMetadata>;
    languageCode: Meal.languageCode;
    tags?: Array<string>;
    mealRatingStats?: MealRatingStats;
    currentUserRating?: number;
    public?: boolean;
};
export namespace Meal {
    export enum languageCode {
        EN = 'EN',
        CS = 'CS',
        SK = 'SK',
    }
}

